import React from "react";
import { Container, Typography, Box } from "@mui/material";

export default function AuditClosure({ closureText }) {
  return (
    <Container
      maxWidth="md"
      sx={{ p: 2, minHeight: { xs: "670px", md: "860px" } }}
    >
      <Box sx={{ px: { xs: 2, md: 5 }, pt: 8, pb: { xs: 5, md: 10 } }}>
        <Typography
          variant="h3"
          align="center"
          fontWeight="bold"
          gutterBottom
          sx={{ mb: 2 }}
        >
          Audit Closure
        </Typography>
        <Box mb={4}>
          <div dangerouslySetInnerHTML={{ __html: closureText }} />
        </Box>
      </Box>
    </Container>
  );
}
